import React from 'react'
import { SeeAllContainer, SeeAllResultsUi } from '@islandsstofa/react'
import { Link } from '@kogk/gatsby-theme-base'
import useGetCompanies from '@src/hooks/useGetCompanies'
import { CompanyCard } from '@cmp/site/Cards'

const Results = () => {
  const companies = useGetCompanies()

  if (!companies) return null

  return (
    <SeeAllResultsUi
      cards={companies}
      onRender={card => (
        <Link key={card.url} to={card.url}>
          <CompanyCard
            containerClass='card--tall'
            card={card}
            image={card.image}
            excerptMaxLen={200}
          />
        </Link>
      )}
    />
  )
}

export default () => {
  return (
    <SeeAllContainer>
      <Results />
    </SeeAllContainer>
  )
}
